/**
 * @generated SignedSource<<fd41d874d0217a2776c2e314fbc20677>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditPersonForm_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PersonActionButtons_user">;
  readonly " $fragmentType": "EditPersonForm_user";
};
export type EditPersonForm_user$key = {
  readonly " $data"?: EditPersonForm_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditPersonForm_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditPersonForm_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonActionButtons_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "4f1c69b5064f9dcd93651844c1ae9cd6";

export default node;
